import * as yup from 'yup';

const ProfileImageSchema = () =>
  yup.object().shape({
    profileImage: yup.mixed(),
  });

export default ProfileImageSchema;
